<template>
  <div class="register-page">
    <header class="topbar">
      <div class="topbar-inner">
        <div class="brand">TaskLink</div>
      </div>
    </header>

    <div class="stage">
      <div class="register-card">
        <!-- 卡片头部：左标题 + 右链接 -->
        <div class="card-header">
          <div class="title">账号注册</div>
          <div class="to-login">
            <span class="muted">已有账号，</span>
            <span class="link" @click="router.push('/login')">去登录</span>
          </div>
        </div>

        <div class="card-body">
          <div class="form-wrap">
            <el-form :model="form" class="form" label-position="top">
              <el-form-item label="名称">
                <el-input v-model="form.name" placeholder="请输入名称" clearable>
                  <template #prefix>
                    <span class="ui-prefix-box">
                      <img class="ui-prefix" :src="iconAccount" alt="" />
                    </span>
                  </template>
                </el-input>
              </el-form-item>

              <el-form-item label="手机号 / 邮箱">
                <el-input v-model="form.account" placeholder="请输入手机号/邮箱登录密码" clearable>
                  <template #prefix>
                    <span class="ui-prefix-box">
                      <img class="ui-prefix" :src="iconAccount" alt="" />
                    </span>
                  </template>
                </el-input>
              </el-form-item>

              <el-form-item label="验证码">
                <el-input v-model="form.code" placeholder="验证码" clearable>
                  <template #suffix>
                    <el-button class="code-btn" link type="success">获取验证码</el-button>
                  </template>
                </el-input>
              </el-form-item>

              <el-form-item label="密码">
                <el-input
                  v-model="form.password"
                  type="password"
                  placeholder="请输入密码"
                  show-password
                >
                  <template #prefix>
                    <span class="ui-prefix-box">
                      <img class="ui-prefix" :src="iconPassword" alt="" />
                    </span>
                  </template>
                </el-input>
              </el-form-item>

              <el-form-item label="确认密码">
                <el-input
                  v-model="form.confirmPassword"
                  type="password"
                  placeholder="请再次输入密码"
                  show-password
                >
                  <template #prefix>
                    <span class="ui-prefix-box">
                      <img class="ui-prefix" :src="iconPassword" alt="" />
                    </span>
                  </template>
                </el-input>
              </el-form-item>

              <el-button type="success" class="submit-btn" @click="handleRegister">
                登 录
              </el-button>

              <div class="agreement">
                <el-checkbox v-model="agree" />
                <span class="agreement-text">
                  我已阅读并同意
                  <span class="a">《用户协议》</span>
                  和
                  <span class="a">《隐私政策》</span>
                </span>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable vue/multi-word-component-names */
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import iconAccount from '@/assets/iconAccount.png'
import iconPassword from '@/assets/iconPassword.png'

const router = useRouter()
const agree = ref(false)

const form = reactive({
  name: '',
  account: '',
  code: '',
  password: '',
  confirmPassword: '',
})

const handleRegister = () => {
  router.push('/home')
}
</script>

<style scoped lang="scss">
.register-page {
  :deep(input.el-input__inner) {
    background: transparent !important;
    font-size: 16px;
    // -webkit-text-fill-color: #A2A9B4 !important; /* autofill 时文字颜色不发灰 */
    // caret-color: #A2A9B4;
  }

  /* 关键：覆盖浏览器自动填充的底色 */
  :deep(input.el-input__inner:-webkit-autofill),
  :deep(input.el-input__inner:-webkit-autofill:hover),
  :deep(input.el-input__inner:-webkit-autofill:focus),
  :deep(input.el-input__inner:-webkit-autofill:active) {
    /* 用内阴影把 autofill 的背景“涂白/涂透明” */
    -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
    box-shadow: 0 0 0 1000px #ffffff inset !important;

    /* 避免闪烁 */
    transition: background-color 999999s ease-out 0s;
    -webkit-text-fill-color: #A2A9B4 !important;
  }

  /* 避免 prefix/suffix 区域也出现分块底色 */
  :deep(.el-input__prefix),
  :deep(.el-input__suffix),
  :deep(.el-input__suffix-inner),
  :deep(.el-input__password) {
    background: transparent !important;
  }

  /* 如果你希望整个 wrapper 永远是白底，而不是透明叠背景 */
  :deep(.el-input__wrapper) {
    background: #fff !important;
  }
}
$green: #4CAF50;
$green-hover: #2f9f35;
$placeholder: #A2A9B4;
$text: #374151;
$border: #e5e7eb;

.register-page {
  min-height: 100vh;
  background-image: url('@/assets/未标题-1 1.png');
  display: flex;
  flex-direction: column;

  .topbar {
    height: 88px;
    display: flex;
    align-items: center;
    background: #ffffffa6;

    .topbar-inner {
      width: min(1200px, calc(100% - 96px));
      margin: 0 auto;
    }

    .brand {
      font-family: 'Playfair Display', serif;
font-weight: 500;
font-size: 36px;
color: #333333;
    }
  }

  .stage {
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 40px 0 60px;
  }

  /* 大卡片（截图类似：更“铺开”） */
  .register-card {
    width: min(1400px, calc(100% - 120px));
    background: rgba(255,255,255,0.6);
    // border: 1px solid rgba(230, 236, 232, 0.95);
    // border-radius: 6px;
    // box-shadow: 0 10px 26px rgba(20, 30, 25, 0.08);
    overflow: hidden;
  }

  .card-header {
    height: 108px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 48px;
    border-bottom: 1px solid #D3D3D3;
    background: rgba(255, 255, 255, 0.35);

    .title {
        font-weight: 400;
font-size: 32px;
color: #000000;
    }

    .to-login {
      font-size: 18px;

      .muted {
        color: #000000;
      }

      .link {
        color: $green;
        cursor: pointer;
        user-select: none;

        &:hover {
          color: $green-hover;
          text-decoration: underline;
        }
      }
    }
  }

  .card-body {
    padding: 34px 0 44px;
  }

  /* 表单居中窄列 */
  .form-wrap {
    width: min(520px, 92vw);
    margin: 0 auto;
  }

  .form {
    :deep(.el-form-item) {
      margin-bottom: 22px;
    }
    :deep(.el-form-item__content) {
        width: 468px;
    }
    :deep(.el-form-item__label) {
      padding: 0 0 6px;
      line-height: 1.2;
      font-size: 14px;
      color: #374151;
    }
  }

  /* ============= Input 边框方案（复用你的 Login.vue） ============= */
  :deep(.el-input__wrapper) {
    height: 56px;
    padding: 0 12px;
    border-radius: 6px;

    background: #fff !important;
    border: none !important;
    box-shadow: none !important;

    position: relative;
    overflow: visible !important;
  }

  :deep(.el-input__wrapper::after) {
    content: '';
    position: absolute;
    inset: 0;
    // border-radius: 6px;
    pointer-events: none;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #D1D5DB;
    z-index: 1 !important;
  }

  :deep(.el-input__wrapper.is-focus::after) {
    border-color: rgba(69, 176, 74, 0.65);
  }

  .register-page {
  /* 输入文字颜色（实际输入值） */
  :deep(input.el-input__inner) {
    background: transparent !important;
    color: #374151 !important;                 /* 非 autofill 的正常情况 */
    -webkit-text-fill-color: #374151 !important; /* 兼容 webkit */
    caret-color: #374151;
 
  }

  /* placeholder 颜色 */
  :deep(input.el-input__inner::placeholder) {
    color: #a2a9b4 !important;
  }
  :deep(input.el-input__inner::-webkit-input-placeholder) {
    color: #a2a9b4 !important;
  }
  :deep(input.el-input__inner::-moz-placeholder) {
    color: #a2a9b4 !important;
    opacity: 1;
  }

  /* 覆盖浏览器自动填充的底色 + 文字颜色 */
  :deep(input.el-input__inner:-webkit-autofill),
  :deep(input.el-input__inner:-webkit-autofill:hover),
  :deep(input.el-input__inner:-webkit-autofill:focus),
  :deep(input.el-input__inner:-webkit-autofill:active) {
    -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
    box-shadow: 0 0 0 1000px #ffffff inset !important;

    transition: background-color 999999s ease-out 0s;

    /* autofill 时文字颜色强制为输入色 */
    -webkit-text-fill-color: #374151 !important;
    caret-color: #374151;
  }

  /* 避免 prefix/suffix 分块背景 */
  :deep(.el-input__prefix),
  :deep(.el-input__suffix),
  :deep(.el-input__suffix-inner),
  :deep(.el-input__password) {
    background: transparent !important;
  }

  /* wrapper 白底 */
  :deep(.el-input__wrapper) {
    background: #fff !important;

  }
}

  /* ============= Prefix Icon ============= */
  .ui-prefix-box {
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .ui-prefix {
    width: 20px;
    height: 20px;
    display: block;
    opacity: 0.85;
    image-rendering: pixelated;
  }

  :deep(.el-input__prefix) {
    display: inline-flex;
    align-items: center;
    margin-right: 6px;
  }

  /* ============= Code Button ============= */
  .code-btn {
    font-size: 16px;
    font-weight: 500;
    color: $green;
    padding: 0 4px;

    &:hover {
      color: $green-hover;
    }
  }

  /* ============= Submit Button ============= */
  .submit-btn {
    margin-top: 6px;
    height: 48px;
    border-radius: 4px;
    width: 468px;
    font-size: 16px;
    letter-spacing: 4px;
    background: $green;
    border-color: $green;

    &:hover {
      background: #3aa842;
      border-color: #3aa842;
    }
  }

  /* ============= Agreement ============= */
  .agreement {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: $text;
   
    font-size: 14px;
    width: 468px;
  }

  :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: $green !important;
    border-color: $green !important;
  }

  :deep(.el-checkbox__input .el-checkbox__inner:hover) {
    border-color: $green !important;
  }

  .agreement-text {
    .a {
      color: $green;
      cursor: pointer;

      &:hover {
        color: $green-hover;
      }
    }
  }
}

/* 响应式：小屏减少外边距 */
@media (max-width: 980px) {
  .register-page {
    .register-card {
      width: min(96vw, 980px);
    }
    .card-header {
      padding: 0 18px;
      height: auto;
      gap: 10px;
      flex-direction: column;
      align-items: flex-start;
      padding-top: 14px;
      padding-bottom: 14px;
    }
  }
}
</style>